<main class="login">
  <section class="login__section_left"></section>
  <section class="login__section_right">
    <form class="login__section_right__form" [formGroup]="loginForm">
      <div class="login__section_right__form__logo"></div>
      <h1 class="login__section_right__form__title">Fazer login - Portal do Cliente</h1>
      <mat-form-field
        class="login__section_right__form__input"
        appearance="outline">
        <mat-label>Selecione o tipo de login</mat-label>
        <mat-select (selectionChange)="changeLoginType($event.value)">
          <mat-option *ngFor="let loginType of loginTypes" [value]="loginType">
            {{ loginType.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="login__section_right__form__input"
        appearance="outline"
        *ngIf="currentLoginType">
        <mat-label>{{ currentLoginType.label }}</mat-label>
        <mat-icon matPrefix class="login__section_right__form__input__icon">
          {{ currentLoginType.icon }}
        </mat-icon>
        <input
          matInput
          formControlName="login"
          type="{{ currentLoginType.type }}"
          mask="{{ currentLoginType.mask }}"
          required />
      </mat-form-field>

      <mat-form-field
        class="login__section_right__form__input"
        appearance="outline">
        <mat-icon matPrefix class="login__section_right__form__input__icon">
          lock
        </mat-icon>
        <mat-label>Senha</mat-label>
        <input type="{{ passwordVisible ? 'text' : 'password' }}" matInput formControlName="senha" required />
        <button type="button" mat-icon-button matSuffix (click)="passwordVisible = !passwordVisible">
          <mat-icon class="login__section_right__form__input__icon">
            {{ passwordVisible ? 'visibility' : 'visibility_off' }}
          </mat-icon>
        </button>
      </mat-form-field>

      <div class="login__section_right__form__row">
        <mat-checkbox
          class="login__section_right__form__checkbox"
          formControlName="manterConectado">
          Manter conectado
        </mat-checkbox>
        <a class="login__section_right__form__link" routerLink="recuperar-senha">
          Esqueci minha senha
        </a>
      </div>

      <mat-error class="login__section_right__form__error" *ngIf="loginForm.hasError('incorrect')">
        {{ loginForm.errors?.['message'] }}
      </mat-error>

      <app-spinner-animation class="login__section_right__form__animation" *ngIf="isSubmitting" />

      <button
        class="login__section_right__form__button"
        type="submit"
        mat-raised-button
        [disabled]="!loginForm.valid || isSubmitting"
        (click)="submit()">
        Entrar
      </button>
    </form>
  </section>
</main>
